import { render, staticRenderFns } from "./usuarioForm.vue?vue&type=template&id=3b1f9d4a&"
import script from "./usuarioForm.vue?vue&type=script&lang=js&"
export * from "./usuarioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports